import { environment } from '../../../environments/environment';

export class ApiConstants {
  static get baseURL(): string {
    return environment.apiBaseUrl;
  }

  static get apiURLs(): any {
    return {
      login: 'spot/authenticate',
      logout: 'spot/logout',
      getClientBuid: 'spot/client',
      resetPassword: 'spot/reset-password',
      getServerTime: 'spot/servertime/{buid}',
      updatePassword: 'spot/update-password',
      fetchManageApprovalConfig: 'spot/managerApprovalWorkFlow/{client}',
      getApproverDetails: "spot/bookings/getApproverDetails/{buid}/{client}",
      fetchConfig: 'spot/config/{client}',
      fetchEmployee: 'spotETS/{buId}/employee/{employeeGuid}',
      fetchEmployees: 'spotETS/{buId}/employees/{employeeGuid}/{searchQuery}',
      fetchEtsData: 'spotETS/etsData/{buId}',
      fetchAirports: 'spot/cityAirportMap/{client}',
      fetchFilteredBooking: 'spot/bookingList',
      defaultCard: 'spot/payment/defaultCard',
      getAllInvoiceDocument: 'spot/invoice/getDocumentList',
      viewUploadedDocument: 'spot/invoice/download-document',
      downLoadZip: 'spot/invoice/download-zip',
      initiatePayment: 'spot/payment/paymentInitiated',
      fetchCutoff: 'spot/cutoff/{client}',
      fetchNotificationInfo: 'spot/notifications/info',
      fetchNotificationConfig: 'spot/notificationConfig/{client}',
      fetchEditConfig: 'spot/editBookingConfig/{client}',
      fetchMiscConfig: 'spot/miscellaneousConfig/{client}',
      designationBasedConfig: 'spot/designatioBasedCab/{client}',
      fetchWorkflowConfig: 'spot/workflowConfig/{client}',
      createBooking: 'spot/bookings',
      cancelBooking: 'spot/bookings/cancelBookings',
      updateBooking: 'spot/bookings/{bookingId}',
      fetchBookings: 'spot/bookingsView',
      fetchVendorBookings: 'spot/getBookingsForVendor',
      fetchBookingsSummary: 'spot/getSummaryCount',
      fetchBookingDetails: 'spot/bookings/{bookingId}',
      fetchRequestDetails: 'spot/requests/{requestId}',
      cancelBookingCutoff: 'spot/cancelBookingConfig/{client}',
      fetchBookingHistory: 'spot/getAuditHistory/{bookingId}',
      editBookingCutoff: 'spot/editBookingConfig',
      fetchAllRequests: 'spot/requests',
      bookingBulkUpdate: 'spot/bookings/multiBookingsUpdate',
      downloadBookingDetails: 'spot/bookingsReport',
      fetchDisableActionsConfig: 'spot/disableActionConfig/{client}',
      getBookingGarage: 'spot/fetch/garagemapping',
      getGarageOptions: 'spot/get/garagemapping',
      updateBookingGarage: 'spot/save/garagemapping',
      fetchBulkUploadTemplate: 'spot/downloadBulkUploadTemplate/{client}/{buid}/{empGuid}',
      fetchMultiStopBulkUploadTemplate: 'spot/downloadMultiStopBulkUploadTemplate/{client}/{buid}/{empGuid}',
      uploadBulkBooking: 'spot/excelBulkUpload/{client}',
      mergeBooking: 'spot/merge-bookings',
      searchBookings: '/spot/searchBookings',
      searchVendorBookings: '/spot/searchBookingsForVendor',

      fetchBillingTemplate: 'spot/downloadDefaultTemplate',
      uploadBillingReport: 'spot/excelFileUpload',
      fetchBillingReport: 'spot/rawBillingReportDownload',
      fetchTripAmountReport: 'spot/tripAmountReportDownload',
      fetchInvoices: 'spot/invoiceAndApprovalStatus/{client}',
      downloadInvoice: 'spot/downloadInvoiceInPDFURL',
      sendInvoice: 'spot/InvoiceCommunication',
      generateInvoice: 'spot/generateJpegOfInvoice',
      downloadAsCsv: 'spot/signInReport/{client}',
      fetchLastUploadedFile: 'spot/downloadRecentFile',
      viewRateCard: 'spot/download-recentratecard',
      uploadRateCard: 'spot/upload-ratecard',
      updateInvoiceStatus: 'spot/updateApprovalStatus',
      updateRiderInvoice: 'spot/invoice/updateRiderInvoice',
      fetchInvoiceImageBlob: 'spot/generateJpegOfInvoice',
      cabAvailability: 'spot/cabAvailability/{bookingId}',
      updateInvoice: 'spot/invoice/updateBillingInfoByBookingId',
      uploadInvoiceFiles: 'spot/invoice/upload-document/{fileType}/{bookingId}',
      fetchInvoiceAdjustment: 'spot/invoice/getAdjustmentInfo/{bookingId}',
      getBillingInfoByBookingid: 'spot/invoice/getBillingInfoByBookingid',
      fetchInvoiceTripInfo: 'spot/invoice/getTripParams',
      fetchPaymentCart: 'spot/BookingPayments',

      fetchCommTemplates: 'spot/UICommConfig/{client}',
      sendCommunication: 'spot/communication',
      updateGeoCords: 'spot/updateGeoCords',
      addCab: 'spot/cabs',
      getTrackInfo: 'spot/tracking',
      getPaymentConfig: 'spot/paymentConfig/{client}/{buid}',
      fetchCardDetails: 'spot/payment/fetchCard',
      removeCard: 'spot/payment/removeCard',

      sendPaymentInfo: 'spot/transactionRefIdUpdate',
      createOrder: 'spot/payment/createOrder',
      openRazorPayForAddingCard: 'spot/payment/authTransaction',
      verifyPayment: 'spot/payment/verifyPayment',
      assignData: 'spotETS/spotFiltersData/{buid}',
      downloadGenerateReports: 'spot/spot-billing',

      vendorAllocation: 'spot/vendorAllocationPercentages/{buid}/{city}',
      vehicleAllocation: 'spot/vehicleDesignationConfig/{buid}/{city}',
      updateHighCapVehicle: 'spot/highCapVehicleConfig/{buid}',
      fetchRiderCab: 'spot/vehicleDesignationConfigForRiders/{buid}/{city}',
      fetchAllEmployeesByRole: 'spot/fetchAllEmployeesByRole/{buid}',

      submitRecipient: 'spot/representativeInfo/{buid}',
      fetchRecipient: 'spot/representativeDetails/{buid}',

      cityOfficeMapping: 'spot/officesByCity/{buid}/{city}',
      fetchLogo: 'spot/webLogo/{buid}',

      fetchDocuments: 'spot/listDoc',
      fetchMarshals: 'spot/fetchEmployeeByRole/{buid}/escort/{bookingID}',
      fetchMarshalOffice: 'spotETS/officeData/{buid}',
      fetchEscortConfig: 'spot/escortConfig/{buid}/{client}/{empGuid}',

      fetchRequesters: 'spot/riderRequesterTypes/{client}',
      addCostCenter: 'spotETS/costCenter/{buId}',
      policyPopupData: 'spot/companyPolicy/{buId}/{client}/{city}',
      fetchCityCutoff: 'spot/creationCutOff/{client}',
      verifyEngagementCode: 'spot/verifyEngagementCode',
      cityTransportMap:'spot/cityTransportMap',
      vendorAllocationConfig: 'spot/vendorAllocationPercentagesConfig/{buid}',
      estimatedDataCall:'spot/getBookingEstimates'
    };
  }
}
